import React, { useEffect, useState } from "react";
import { Chip, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { generateRandomID } from "helpers/generateRandomID";
import { addLabelArray } from "helpers/addLabelArray";

export const MyAutoComplete = (props) => {
  const {
    label = "",
    value = null,
    options = [],
    action = () => { },
    helperText = "",
    keySort = "",
    size = "small",
  } = props
  const [sOptions, setSOptions] = useState([])
  const id = React.useMemo(() => generateRandomID(10), []);

  useEffect(() => {
    if (keySort.length > 0) {
      const addLabel = addLabelArray(options, keySort)

      setSOptions(addLabel)
    }
  }, [options])

  return (
    <Autocomplete
      id={id}
      options={sOptions}
      value={value}
      getOptionLabel={(option) => option?.label || ""}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            variant="outlined"
            label={option.label}
            {...getTagProps({ index })}
            style={{
              borderRadius: 4,
            }}
          />
        ))
      }
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" size={size} />
      )}
      fullWidth
      onChange={(e, v) => action(v)}
      noOptionsText={helperText}
    />
  );
};
